import { useNavigate } from "react-router-dom";
import { X, Lightbulb } from "lucide-react";
import type { FeatureTip } from "@/hooks/useFeatureTips";
import { trackFeatureTipClicked, trackFeatureTipDismissed } from "@/analytics/analytics";

interface FeatureTipStripProps {
  tip: FeatureTip;
  onDismiss: (tipId: string) => void;
  onAction: (tip: FeatureTip) => void;
}

const FeatureTipStrip = ({ tip, onDismiss, onAction }: FeatureTipStripProps) => {
  const navigate = useNavigate();

  const handleAction = () => {
    trackFeatureTipClicked({ tipId: tip.id, action: tip.action.type });
    if (tip.action.type === "navigate") {
      navigate(tip.action.path);
    } else {
      onAction(tip);
    }
  };

  const handleDismiss = () => {
    trackFeatureTipDismissed({ tipId: tip.id });
    onDismiss(tip.id);
  };

  return (
    <div className="border-b border-primary/10 bg-primary/[0.03] text-xs px-4 py-2 flex items-center gap-2">
      <Lightbulb className="h-3.5 w-3.5 text-primary-text shrink-0" />
      <span className="font-bold text-foreground">TIP</span>
      <span className="text-muted-foreground truncate">{tip.description}</span>
      <button
        type="button"
        onClick={handleAction}
        className="text-primary-text font-medium shrink-0 hover:underline"
      >
        {tip.action.type === "navigate" ? "Go" : "Try it"}
      </button>
      <button
        type="button"
        onClick={handleDismiss}
        className="text-muted-foreground/40 hover:text-muted-foreground transition-colors shrink-0 p-0.5 ml-auto"
        aria-label="Dismiss"
      >
        <X className="h-3 w-3" />
      </button>
    </div>
  );
};

export default FeatureTipStrip;
